import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { CountdownTimer } from './ui/CountdownTimer';
import { trackAddToCart } from '../hooks/useMetaPixel';
export function CTASection() {
  return <section id="pricing" className="py-16 md:py-24 px-4 md:px-6 bg-navy" data-id="element-88">
      <div className="max-w-5xl mx-auto" data-id="element-89">
        <FadeIn data-id="element-90">
          <div className="text-center mb-12" data-id="element-91">
            <div className="inline-block bg-navy-light border border-white/10 text-white/80 font-medium text-xs md:text-sm px-4 py-1.5 rounded-full mb-6 uppercase tracking-wider" data-id="element-92">
              Oferta de lanzamiento
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-white leading-tight" data-id="element-93">
              Todo lo que necesitas
              <br data-id="element-94" />
              por menos de lo que cuesta
              <br data-id="element-95" />
              <span className="text-gold italic" data-id="element-96">una salida a comer</span>
            </h2>
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-97">
          <div className="max-w-2xl mx-auto bg-white rounded-3xl overflow-hidden shadow-2xl border-2 border-gold/30" data-id="element-98">
            {/* Header */}
            <div className="bg-gradient-to-br from-navy to-navy-mid p-10 md:p-12 text-center text-white relative" data-id="element-99">
              {/* Curved bottom edge */}
              <div className="absolute -bottom-px left-0 right-0 h-10 bg-white" style={{
              clipPath: 'ellipse(60% 100% at 50% 100%)'
            }} data-id="element-100" />

              <div className="text-xs font-bold tracking-widest uppercase text-gold mb-3" data-id="element-101">
                Acceso completo inmediato
              </div>
              <div className="font-serif text-2xl font-bold mb-6" data-id="element-102">
                Guía del Sueño del Bebé + 3 Bonos
              </div>
              <div className="flex items-baseline justify-center gap-2" data-id="element-103">
                <span className="text-2xl font-bold text-white/70" data-id="element-104">$</span>
                <span className="font-serif text-7xl md:text-8xl font-black text-white leading-none" data-id="element-105">
                  6.39
                </span>
                <span className="text-lg text-white/40 line-through" data-id="element-106">
                  $12.99
                </span>
              </div>
              <div className="mt-3 text-sm text-gold font-semibold" data-id="element-107">
                Ahorras más del 50%
              </div>
            </div>

            {/* Body */}
            <div className="p-8 md:p-12" data-id="element-108">
              <div className="mb-6" data-id="element-109">
                <CountdownTimer data-id="element-110" />
              </div>

              <div className="text-xs font-bold tracking-widest uppercase text-gray-400 mb-5" data-id="element-111">
                Tu pack incluye:
              </div>

              <ul className="flex flex-col gap-3 mb-8" data-id="element-112">
                {[{
                icon: '📖',
                name: 'Guía del Sueño del Bebé',
                sub: '47 páginas · PDF descargable',
                val: '$47'
              }, {
                icon: '📊',
                name: 'Planificador de Sueño',
                sub: 'Bonus #1 · PDF imprimible',
                val: '$17'
              }, {
                icon: '🚨',
                name: 'Guía de Regresiones',
                sub: 'Bonus #2 · 4, 8 y 12 meses',
                val: '$27'
              }, {
                icon: '✅',
                name: 'Checklist Habitación Perfecta',
                sub: 'Bonus #3 · Aplicable hoy',
                val: '$12'
              }].map((item, i) => <li key={i} className="flex items-center justify-between pb-3 border-b border-gray-100 last:border-0 last:pb-0" data-id="element-113">
                    <div className="flex items-center gap-3" data-id="element-114">
                      <div className="w-9 h-9 bg-gray-50 rounded-lg flex items-center justify-center text-base" data-id="element-115">
                        {item.icon}
                      </div>
                      <div data-id="element-116">
                        <div className="text-sm font-semibold text-gray-900" data-id="element-117">
                          {item.name}
                        </div>
                        <div className="text-xs text-gray-500" data-id="element-118">{item.sub}</div>
                      </div>
                    </div>
                    <div className="text-sm font-bold text-gray-400" data-id="element-119">
                      {item.val}
                    </div>
                  </li>)}
              </ul>

              <div className="flex items-center justify-between bg-gray-50 rounded-xl p-4 mb-8" data-id="element-120">
                <div className="text-sm font-bold text-gray-600" data-id="element-121">
                  Valor total del pack
                </div>
                <div className="flex items-center gap-3" data-id="element-122">
                  <span className="text-sm text-gray-400 line-through" data-id="element-123">
                    $12.99
                  </span>
                  <span className="font-serif text-2xl font-black text-navy" data-id="element-124">
                    $6.39 hoy
                  </span>
                </div>
              </div>

              <Button href="https://maternidadenequilibrio.com/cart/48914468045024:1" onClick={trackAddToCart} className="w-full py-5 text-lg animate-[pulse_2.5s_ease-in-out_infinite]" data-id="element-125">
                🌙 Quiero Dormir Mejor — $6.39
              </Button>

              <p className="text-center text-xs text-gray-500 mt-4" data-id="element-126">
                🔒 Pago seguro · Acceso inmediato · PDF descargable
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}